/*
    TODO:
        FILES COULD BE UPDATED TO INCLUDE MORE
        (OR LESS IF WE KNOW WE NEVER WILL ACCEPT CERTAIN FILES)
*/

export const images = [
  'image/png',
  'image/jpeg',
  'image/apng',
  'image/bmp',
  'image/gif',
  'image/pjpeg',
  'image/svg+xml',
  'image/tiff',
  'image/webp',
  'image/x-icon',
  'image/*',
  '.png',
  '.jpeg',
  '.jpg',
  '.apng',
  '.bmp',
  '.gif',
  '.pjpeg',
  '.svg+xml',
  '.tiff',
  '.webp',
  '.x-icon',
];

export const audio = [
  'audio/mpeg',
  'audio/mpeg3',
  'audio/wav',
  'audio/ogg',
  'audio/*',
  '.aiff',
  '.asf',
  '.avi',
  '.flv',
  '.f4v',
  '.mov',
  '.mpg',
  '.mp3',
  '.mp4',
  '.mts',
  '.m2t',
  '.m4a',
  '.m4b',
  '.m4v',
  '.ra',
  '.rm',
  '.wav',
  '.webm',
  '.wma',
  '.wmx',
];

export const video = ['video/*'];

export const documents = [
  '.pdf',
  '.xlsx',
  '.xls',
  '.doc',
  '.docx',
  '.ppt',
  '.pptx',
  '.txt',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
];

export default {
  images,
  audio,
  video,
  documents,
};
